/* ─── Permanent variant ─── */

.permanent {
  position: fixed;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  width: 360px;
  background: var(--md-surface-container-low);
  overflow-y: auto;
  z-index: var(--z-sticky);
  padding: var(--space-4);
  font-family: var(--font-sans);
}

.permanent[data-side="right"] {
  inset-inline-start: auto;
  inset-inline-end: 0;
}

/* ─── Nav list ─── */

.nav {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

/* ─── Item ─── */

.item {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  height: 3.5rem;
  padding: 0 var(--space-4);
  border-radius: var(--shape-full);
  border: none;
  background: transparent;
  color: var(--md-on-surface-variant);
  font-family: var(--font-sans);
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  text-align: start;
}

.item::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .item:hover::before {
    opacity: var(--state-hover);
  }
}

.item:focus-visible::before {
  opacity: var(--state-focus);
}

.item:active::before {
  opacity: var(--state-pressed);
}

.item[data-active] {
  background: var(--md-primary-container);
  color: var(--md-on-primary-container);
  font-weight: 500;
}

.item[data-active]::before {
  background: var(--md-on-primary-container);
}

/* ─── Item icon ─── */

.itemIcon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ─── Group ─── */

.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

/* ─── Group label ─── */

.groupLabel {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  font-weight: 600;
  color: var(--md-on-surface-variant);
  padding: var(--space-3) var(--space-4) var(--space-1);
}

/* ─── Divider ─── */

.divider {
  height: 1px;
  background: var(--md-outline-variant);
  border: none;
  margin: var(--space-2) 0;
}
